import { DELETE, GET, POST, PUT } from "@/utils/http";

const APPROVER_BASE_URI = "/user";

export const UserService = {
  create(
    request: CreateUserRequest,
  ): Promise<SuccessResponse | null | undefined> {
    return POST<SuccessResponse>(
      `${APPROVER_BASE_URI}/create`,
      request,
      undefined,
      true,
    );
  },
  update(
    userId: number,
    request: CreateUserRequest,
  ): Promise<SuccessResponse | null | undefined> {
    return PUT<SuccessResponse>(`${APPROVER_BASE_URI}/edit`, request, {
      params: { userId: userId },
    });
  },
  getDetail(userId: number): Promise<UserDetail | null | undefined> {
    return GET<UserDetail>(
      `${APPROVER_BASE_URI}/detail/${userId}`,
      undefined,
      true,
    );
  },
  delete(userId: number): Promise<SuccessResponse | null | undefined> {
    return DELETE<SuccessResponse>(`${APPROVER_BASE_URI}/delete/${userId}`);
  },
  search(
    request: SearchUserListRequest,
  ): Promise<SearchUserResponse | null | undefined> {
    return POST<any>(`${APPROVER_BASE_URI}/search`, request);
  },
  changePassword(
    request: ChangePasswordRequest,
  ): Promise<SuccessResponse | null | undefined> {
    return POST<SuccessResponse>(
      `${APPROVER_BASE_URI}/change-password`,
      request,
      undefined,
      true,
    );
  },
};
